import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-start gap-4" }
const _hoisted_2 = {
  class: "d-flex align-center justify-center rounded-circle flex-shrink-0",
  style: {"width":"48px","height":"48px","background-color":"#e3f2fd"}
}
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = {
  class: "d-flex align-center flex-wrap gap-2 pa-3 rounded mb-3",
  style: {"background":"#f5f5f5"}
}
const _hoisted_5 = { class: "text-body-2 font-weight-medium" }

import LlSecondaryButton from '@/components/LlSecondaryButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpdateMatterStageDialog',
  props: {
  modelValue: { type: Boolean, default: false },
  currentStage: { type: String, default: 'Active' },
},
  emits: ['update:modelValue', 'not-now', 'update-stage'],
  setup(__props) {





return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": __props.modelValue,
    "max-width": "480",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        rounded: "lg",
        class: "pa-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "pt-6 pb-3" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    color: "blue-darken-2",
                    size: "26"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-check-circle", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_3, [
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-h6 font-weight-bold mb-1" }, "Update Matter Stage?", -1)),
                  _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-body-2 text-grey-darken-1 mb-4" }, " Your settlement statement is ready. Would you like to update the matter stage? ", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Current stage:", -1)),
                    _createElementVNode("span", _hoisted_5, _toDisplayString(__props.currentStage), 1),
                    _createVNode(_component_v_icon, {
                      size: "16",
                      color: "grey-darken-1"
                    }, {
                      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("mdi-arrow-right", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[6] || (_cache[6] = _createElementVNode("span", {
                      class: "text-body-2 font-weight-bold",
                      style: {"color":"#1565c0"}
                    }, "Settlement Pending", -1))
                  ]),
                  _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-caption text-grey-darken-1" }, " This updates the matter stage in LeanLaw. You can always change it later from the matter settings. ", -1))
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, { class: "px-6 pb-5 justify-end gap-2" }, {
            default: _withCtx(() => [
              _createVNode(LlSecondaryButton, {
                variant: "outlined",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('not-now')))
              }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("Not Now", -1)
                ]))]),
                _: 1
              }),
              _createVNode(LlSecondaryButton, {
                color: "primary",
                variant: "elevated",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update-stage')))
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode(" Yes, Update Stage ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})